module.exports = __webpack_public_path__ + "img/upup.909221cf.png";